function DOMready(callback) {
  document.readyState !== 'loading'
    ? callback()
    : document.addEventListener('DOMContentLoaded', callback)
}

DOMready(function () {
  function Ajaxinate(config) {
    const settings = config || {}

    const defaults = {
      method: 'scroll',
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      offset: 0,
      loadingText: 'Loading',
      callback: null,
    }

    // Merge custom configs with defaults
    this.settings = Object.assign(defaults, settings)

    // Functions
    this.addScrollListeners = this.addScrollListeners.bind(this)
    this.addClickListener = this.addClickListener.bind(this)
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)
    this.preventMultipleClicks = this.preventMultipleClicks.bind(this)
    this.removeClickListener = this.removeClickListener.bind(this)
    this.removeScrollListener = this.removeScrollListener.bind(this)
    this.removePaginationElement = this.removePaginationElement.bind(this)
    this.destroy = this.destroy.bind(this)

    // Selectors
    this.containerElement = document.querySelector(this.settings.container)
    this.paginationElement = document.querySelector(this.settings.pagination)
    this.initialize()
  }

  Ajaxinate.prototype.initialize = function initialize() {
    if (!this.containerElement) {
      return
    }

    const initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners,
    }

    initializers[this.settings.method]()
  }

  Ajaxinate.prototype.addScrollListeners = function addScrollListeners() {
    if (!this.paginationElement) {
      return
    }

    document.addEventListener('scroll', this.checkIfPaginationInView)
    window.addEventListener('resize', this.checkIfPaginationInView)
    window.addEventListener('orientationchange', this.checkIfPaginationInView)
  }

  Ajaxinate.prototype.addClickListener = function addClickListener() {
    if (!this.paginationElement) {
      return
    }

    this.nextPageLinkElement = this.paginationElement.querySelector('a')
    this.clickActive = true

    if (
      typeof this.nextPageLinkElement !== 'undefined' &&
      this.nextPageLinkElement !== null
    ) {
      this.nextPageLinkElement.addEventListener(
        'click',
        this.preventMultipleClicks
      )
    }
  }

  Ajaxinate.prototype.preventMultipleClicks = function preventMultipleClicks(
    event
  ) {
    event.preventDefault()

    if (!this.clickActive) {
      return
    }

    this.nextPageLinkElement.innerText = this.settings.loadingText
    this.nextPageUrl = this.nextPageLinkElement.href
    this.clickActive = false

    this.loadMore()
  }

  Ajaxinate.prototype.checkIfPaginationInView =
    function checkIfPaginationInView() {
      const top =
        this.paginationElement.getBoundingClientRect().top -
        this.settings.offset
      const bottom =
        this.paginationElement.getBoundingClientRect().bottom +
        this.settings.offset

      if (top <= window.innerHeight && bottom >= 0) {
        this.nextPageLinkElement = this.paginationElement.querySelector('a')
        this.removeScrollListener()

        if (this.nextPageLinkElement) {
          this.nextPageLinkElement.innerText = this.settings.loadingText
          this.nextPageUrl = this.nextPageLinkElement.href

          this.loadMore()
        }
      }
    }

  Ajaxinate.prototype.loadMore = function loadMore() {
    this.request = new XMLHttpRequest()

    this.request.onreadystatechange = function success() {
      if (!this.request.responseXML) {
        return
      }
      if (!this.request.readyState === 4 || !this.request.status === 200) {
        return
      }

      const newContainer = this.request.responseXML.querySelectorAll(
        this.settings.container
      )[0]
      const newPagination = this.request.responseXML.querySelectorAll(
        this.settings.pagination
      )[0]

      this.containerElement.insertAdjacentHTML(
        'beforeend',
        newContainer.innerHTML
      )

      if (typeof newPagination === 'undefined') {
        this.removePaginationElement()
      } else {
        this.paginationElement.innerHTML = newPagination.innerHTML

        if (
          this.settings.callback &&
          typeof this.settings.callback === 'function'
        ) {
          this.settings.callback(this.request.responseXML)
        }

        this.initialize()

        // Yotpo refresh
        let apiYotpo = new Yotpo.API(yotpo)
        apiYotpo.refreshWidgets()
      }
    }.bind(this)

    this.request.open('GET', this.nextPageUrl)
    this.request.responseType = 'document'
    this.request.send()
  }

  Ajaxinate.prototype.removeClickListener = function removeClickListener() {
    this.nextPageLinkElement.removeEventListener(
      'click',
      this.preventMultipleClicks
    )
  }

  Ajaxinate.prototype.removePaginationElement =
    function removePaginationElement() {
      this.paginationElement.innerHTML = ''
      this.destroy()
    }

  Ajaxinate.prototype.removeScrollListener = function removeScrollListener() {
    document.removeEventListener('scroll', this.checkIfPaginationInView)
    window.removeEventListener('resize', this.checkIfPaginationInView)
    window.removeEventListener(
      'orientationchange',
      this.checkIfPaginationInView
    )
  }

  Ajaxinate.prototype.destroy = function destroy() {
    const destroyers = {
      click: this.removeClickListener,
      scroll: this.removeScrollListener,
    }

    destroyers[this.settings.method]()

    return this
  }

  /* harmony default export */ const ajaxinate =
    /* unused pure expression or super */ null && Ajaxinate // CONCATENATED MODULE: ./src/javascripts/sections/Collection.js

  // Used on Collections for Infinite Scroll & Load More
  // Note:  This function is overriding the version in the npm package, because
  //        that version breaks in the Theme editor.
  //        Github issue reference: https://github.com/Elkfox/Ajaxinate/issues/26

  Ajaxinate.prototype.loadMore =
    function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
      this.request = new XMLHttpRequest()

      this.request.onreadystatechange = function success() {
        let parser = new DOMParser()
        let htmlDoc = parser.parseFromString(
          this.request.responseText,
          'text/html'
        )

        if (this.request.readyState === 4 && this.request.status === 200) {
          let newContainer = htmlDoc.querySelectorAll(
            this.settings.container
          )[0]
          let newPagination = htmlDoc.querySelectorAll(
            this.settings.pagination
          )[0]
          this.containerElement.insertAdjacentHTML(
            'beforeend',
            newContainer.innerHTML
          )
          this.paginationElement.innerHTML = newPagination.innerHTML

          if (
            this.settings.callback &&
            typeof this.settings.callback === 'function'
          ) {
            this.settings.callback(this.request.responseXML)
          }

          this.initialize()

          // Yotpo refresh
          let apiYotpo = new Yotpo.API(yotpo)
          apiYotpo.refreshWidgets()
        }
      }.bind(this)

      this.request.open('GET', this.nextPageUrl)
      this.request.overrideMimeType('text/html')

      // let countPage = 0;
      // let countMore = document.querySelector(".collection-pagination .count i");
      // let content = this.containerElement.children;

      // for (let i = 0; i < content.length; i++) {
      //   let e = content[i];
      //   countPage += e.children.length
      // }

      // countMore.dataset.count = countPage
      // countMore.innerHTML = countPage;

      this.request.send()
    }

  const AjaxinateLoadMore = document.querySelector('#AjaxinateLoadMore')

  if (AjaxinateLoadMore !== undefined || AjaxinateLoadMore !== null) {
    new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinateLoadMore',
      method: 'click',
      loadingText: 'Loading',
    })
  }
})
